import { FaCheck } from "react-icons/fa";

// ExtendedCancellationPeriod هي عناصر قائمة

function ListItem({listItem}) {
  return (
    <li className='flex items-center gap-4 mb-2'>
      <FaCheck className='text-[#8aa954]' />
      {listItem}
    </li>
  )
}

export default ListItem